import React from "react";
import "./Badge.scss";

type BadgeVariant = "active" | "pending" | "rejected" | "draft" | "default" | "info" | "warning";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = "default" }) => {
  return <span className={`badge badge--${variant}`}>{children}</span>;
};

export default Badge;
